import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Search } from 'lucide-react'

// Origin and buyer chips, applied the moment they are clicked, plus the
// lead-ID box. The dashboard endpoint has no search parameter, so an ID
// opens the Lead Inspector, which finds a lead whatever the range.
export default function FilterChips({ filters, origins, buyers, palette, onToggleOrigin, onToggleBuyer, onClear }) {
  const navigate = useNavigate()
  const [leadId, setLeadId] = useState('')
  const hasSelection = origins.length > 0 || buyers.length > 0

  const submit = (e) => {
    e.preventDefault()
    const id = leadId.trim()
    if (!/^\d+$/.test(id)) return
    navigate(`/lead-inspector/${id}`)
  }

  return (
    <section aria-label="Filters" className="card" style={{ padding: 14, display: 'flex', flexDirection: 'column', gap: 10 }}>
      <ChipRow label="Origin">
        {(filters?.origins || []).map((o) => (
          <button key={o} type="button" className="sl-chip" aria-pressed={origins.includes(o)} onClick={() => onToggleOrigin(o)}>
            {o}
          </button>
        ))}
      </ChipRow>
      <ChipRow label="Buyer">
        {(filters?.buyers || []).map((b) => {
          const id = String(b.id)
          return (
            <button key={id} type="button" className="sl-chip" aria-pressed={buyers.includes(id)} onClick={() => onToggleBuyer(id)}>
              <span aria-hidden="true" style={{ width: 8, height: 8, borderRadius: 999, background: palette.forId(id), flexShrink: 0 }} />
              {b.label}
            </button>
          )
        })}
      </ChipRow>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
        <form onSubmit={submit} className="sl-search" style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <label htmlFor="sl-lead-id" style={{ fontSize: 11, fontWeight: 600, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '.04em', minWidth: 52 }}>
            Lead ID
          </label>
          <div style={{ position: 'relative' }}>
            <Search size={13} aria-hidden="true" style={{ position: 'absolute', left: 9, top: '50%', transform: 'translateY(-50%)', color: 'var(--text-muted)' }} />
            <input
              id="sl-lead-id"
              inputMode="numeric"
              placeholder="Open in Lead Inspector"
              value={leadId}
              onChange={(e) => setLeadId(e.target.value)}
              style={{
                padding: '6px 10px 6px 28px', fontSize: 12, borderRadius: 6, width: 210,
                border: '1px solid var(--border)', background: 'var(--bg-surface)', color: 'var(--text-primary)',
              }}
            />
          </div>
        </form>
        {hasSelection && (
          <button type="button" className="btn btn-ghost btn-sm" onClick={onClear} style={{ marginLeft: 'auto' }}>
            Clear filters
          </button>
        )}
      </div>
    </section>
  )
}

function ChipRow({ label, children }) {
  const items = React.Children.toArray(children)
  return (
    <div role="group" aria-label={label} style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
      <span style={{ fontSize: 11, fontWeight: 600, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '.04em', minWidth: 52 }}>
        {label}
      </span>
      {items.length ? items : <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>None in this data</span>}
    </div>
  )
}
